import React, { Component } from "react";
import { Container } from "reactstrap";
import { connect } from "react-redux";
import { Redirect, withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import {
  addContractor,
  getContractorProfile,
  setErrorContractorProfile,
  updateContractorProfile,
} from "../../../../store/contractors/actions";
import ContractorInformationForm from "../AddContractors/components/ContractorInformationForm";
import ModifiedMetaTags from '../../../../components/ModifiedMetaTags/index';

class ContractorsProfile extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.getContractorProfile(this.props.match.params.contractorId);
  }

  componentWillUnmount() {
    this.props.setErrorContractorProfile(false);
  }

  render() {
    const {
      data,
      contactData,
      isError,
      history,
      addContractor,
      updateContractorProfile,
      profileLoader,
      permissions
    } = this.props;

    if (isError) {
      return <Redirect to={"/404"} />;
    }

    return (
      <React.Fragment>
        <div className="page-content">
          <ModifiedMetaTags title="Contractor profile | Mobihunter" />

          <Container fluid>
            <Breadcrumbs
              title="Contractors"
              breadcrumbItem={data?.contract_number}
              link="/contractors"
            />
            <ContractorInformationForm
              data={data}
              contactData={contactData}
              history={history}
              addContractor={addContractor}
              updateContractorProfile={updateContractorProfile}
              contractorId={this.props.match.params.contractorId}
              loader={profileLoader}
              permissions={permissions}
            />
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

ContractorsProfile.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      contractorId: PropTypes.node,
    }).isRequired,
  }).isRequired,
  contactData: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  data: PropTypes.object.isRequired,
  isError: PropTypes.any,
  history: PropTypes.object.isRequired,
  profileLoader: PropTypes.bool.isRequired,
  getContractorProfile: PropTypes.func.isRequired,
  updateContractorProfile: PropTypes.func.isRequired,
  addContractor: PropTypes.func.isRequired,
  setErrorContractorProfile: PropTypes.func.isRequired,
  permissions: PropTypes.any,
};

const mapStateToProps = state => ({
  data: state.ContractorList.profileData,
  profileLoader: state.ContractorList.profileLoader,
  contactData: state.ContractorList.data,
  isError: state.ContractorList.isError,
  permissions: state.User.permissions,
});

export default withRouter(
  connect(mapStateToProps, {
    getContractorProfile,
    updateContractorProfile,
    addContractor,
    setErrorContractorProfile,
  })(ContractorsProfile)
);
